import { commentItems, rankingItems, carouselItems, featureItems, faqItems } from '@/mocks/home';
import { useState } from 'react';

/* ==================== #app ==================== */
export function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[640px] mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            <i className="ri-smartphone-line"></i>
            随时随地
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">
            移动端吃瓜入口
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8 leading-relaxed">
            关注我们的微信公众号或添加小程序，随时随地获取最新瓜料推送。
            扫码即达，吃瓜不等待，快人一步掌握全网热门八卦。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              type="button"
              className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all cursor-pointer"
            >
              <i className="ri-wechat-line mr-2"></i>
              关注公众号
            </button>
            <button
              type="button"
              className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full text-base font-semibold border-2 border-primary-500 text-primary-500 hover:bg-primary-50 transition-all cursor-pointer"
            >
              <i className="ri-apps-line mr-2"></i>
              打开小程序
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

/* ==================== #comments ==================== */
export function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
            <i className="ri-chat-1-line"></i>
            群众声音
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            吃瓜群众热评
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-[960px] mx-auto">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200 rounded-xl p-5 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 shrink-0 rounded-full overflow-hidden bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-900">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-400">{item.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1">
                {item.content}
              </p>
              <div className="flex items-center gap-1 mt-3 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ==================== #ranking ==================== */
export function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            <i className="ri-trophy-line"></i>
            热度排行
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            吃瓜榜单
          </h2>
        </div>

        <div className="max-w-[860px] mx-auto bg-background-50 border border-background-200 rounded-2xl overflow-hidden">
          {rankingItems.map((item, idx) => {
            const rankColors: Record<number, string> = {
              1: 'bg-primary-500 text-background-50',
              2: 'bg-accent-500 text-background-50',
              3: 'bg-accent-400 text-background-50',
            };
            const tagColors: Record<string, string> = {
              '爆': 'bg-primary-500 text-background-50',
              '热': 'bg-accent-100 text-accent-700',
              '新': 'bg-accent-50 text-accent-600',
            };

            return (
              <div
                key={item.rank}
                className={`flex items-center gap-4 px-5 py-4 ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200' : ''
                } hover:bg-background-100 transition-colors cursor-pointer`}
              >
                <span
                  className={`shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-heading ${
                    rankColors[item.rank] || 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
                <p className="flex-1 text-sm md:text-base font-medium text-foreground-800 leading-snug min-w-0">
                  {item.title}
                </p>
                <span className="shrink-0 text-xs text-foreground-500">{item.heat}</span>
                <span
                  className={`shrink-0 px-2 py-0.5 rounded text-xs font-semibold ${
                    tagColors[item.tag] || 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.tag}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

/* ==================== #about ==================== */
export function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[720px] mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
            <i className="ri-information-line"></i>
            关于我们
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-6">
            关于爆料吃瓜
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            爆料吃瓜诞生于2024年，是国内领先的吃瓜网站与爆料网站导航聚合平台。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
            我们专注于为吃瓜群众提供一站式的在线吃瓜导航体验，通过实时追踪微博热搜、豆瓣小组、贴吧爆料、小红书热议、抖音热门等多个主流社交平台，将分散在全网的娱乐圈八卦、网红爆料、综艺内幕、选秀动态等热门瓜料进行智能聚合，帮助用户快速找到吃瓜入口，不再错过任何一个值得关注的热点事件。
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            截至2026年，爆料吃瓜已收录超过500个优质吃瓜资源站点，日均更新瓜料200余条，月活跃吃瓜群众突破80万，是国内吃瓜爱好者最信赖的在线吃瓜导航工具。
          </p>
        </div>
      </div>
    </section>
  );
}

/* ==================== #carousel ==================== */
export function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
            <i className="ri-focus-2-line"></i>
            专题精选
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            焦点专题
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-2xl overflow-hidden bg-background-100 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="inline-block px-2.5 py-1 rounded-full text-xs font-semibold bg-accent-500 text-background-50 mb-3">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-semibold text-white mb-1">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-white/80 line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ==================== #features ==================== */
export function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-3">
            <i className="ri-star-line"></i>
            为什么选我们
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            特色优势
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200 rounded-xl p-6 text-center hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className={`${item.icon} text-xl text-primary-500 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

/* ==================== #faq ==================== */
export function FaqSection() {
  const [openAll] = useState(true);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-3">
            <i className="ri-question-line"></i>
            常见问题
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
            吃瓜常见问答
          </h2>
        </div>

        <div className="max-w-[760px] mx-auto flex flex-col gap-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200 rounded-xl overflow-hidden"
            >
              <div className="px-6 py-5 flex items-start gap-4">
                <div className="w-7 h-7 shrink-0 rounded-full bg-primary-100 flex items-center justify-center mt-0.5">
                  <span className="text-xs font-heading text-primary-500">Q</span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                    {item.question}
                  </h3>
                  {openAll && (
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}